<template>
  <!-- name: '个人信息' -->
  <div class="infoBaseWrap">
    <div class="formClass">
      <img
        :src="objData.headImage"
        alt=""
        class="avaImg"
        v-default-img="defaultImgUrl"
      />
      <div class="itemBox">
        <label for="phone">手机号</label>
        <input
          type="text"
          id="phone"
          v-model="objData.mobile"
          placeholder="请填写您的手机号"
        />
      </div>
      <div class="itemBox">
        <label for="wechat">微信号</label>
        <input
          type="text"
          id="wechat"
          v-model="objData.wechat"
          placeholder="请填写您的微信号"
        />
      </div>
      <div class="itemBox">
        <label for="nickname">系统昵称</label>
        <input
          type="text"
          id="nickname"
          v-model="objData.nickName"
          placeholder="请填写您的系统昵称"
          class="nickname"
          disabled
        />
      </div>
      <div class="itemBox">
        <label for="name">真实姓名</label>
        <input
          type="text"
          id="name"
          v-model="objData.realName"
          placeholder="请填写您的真实姓名"
        />
      </div>
      <div class="itemBox">
        <label>性别</label>
        <input
          type="radio"
          value="1"
          v-model="objData.gender"
          class="radioClass"
        />
        男
        <input
          type="radio"
          value="2"
          v-model="objData.gender"
          class="radioClass"
        />
        女
      </div>
      <div class="itemBox">
        <label for="sendPhone">发货手机号</label>
        <input
          type="text"
          id="sendPhone"
          v-model="objData.shippingMobile"
          placeholder="请填写您的手机号"
        />
      </div>
      <div class="itemBox">
        <label for="email">邮箱</label>
        <input
          type="text"
          id="email"
          v-model="objData.email"
          placeholder="请填写您的邮箱地址"
        />
      </div>
    </div>

    <div class="switchBox">
      <div class="itemBox">
        <label for="isAnonymity">昵称匿名</label>
        <input
          type="checkbox"
          id="isAnonymity"
          v-model="objData.showNickName"
          class="checkboxClass"
          :value="1"
          @change="
            handeChangeNickNameHeadImageStatus(Number(objData.showNickName), 1)
          "
        />
      </div>
      <div class="itemBox">
        <label for="isAvatarPublic">头像公开</label>
        <input
          type="checkbox"
          id="isAvatarPublic"
          v-model="objData.showHeadImage"
          class="checkboxClass"
          @change="
            handeChangeNickNameHeadImageStatus(Number(objData.showHeadImage), 2)
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { userInfo, changeNickNameHeadImageStatus, changeGender } from "@/api/userCenter";
export default {
  components: {},
  data() {
    return {
      objData: {},
      defaultImgUrl: `https://img.bbalt.cn/imgh5/user_default.svg`,
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const { content } = await userInfo();
      this.objData = content;
    },
    async handeChangeNickNameHeadImageStatus(show, type) {
      const { code } = await changeNickNameHeadImageStatus({ show, type });
      if (code === 200) {
        this.getUserInfo();
      }
    },
    async handleChangeGender(gender) {
      const { code } = await changeGender({ gender })
      if (code === 200) {
        this.getUserInfo()
      }
    }
  },
  watch: {
    'objData.gender'(newVal, oldVal) {
      console.log('newVal=' + newVal + 'oldVal=' + oldVal)
      if (newVal && oldVal && newVal != oldVal) {
        this.handleChangeGender(Number(newVal))
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.infoBaseWrap {
  border-top: 1px solid #ededed;
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 85%;
  padding-bottom: 15%;
  overflow: auto;
  background-color: #f5f5f5;
  .avaImg {
    margin-top: 55px;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    margin-bottom: 40px;
  }
  .formClass {
    background-color: #fff;
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .switchBox {
    width: 100%;
    margin-top: 40px;
    background-color: #fff;
    .itemBox {
      justify-content: space-between;
      input[type="checkbox"] {
        background-image: url("https://img.bbalt.cn/imgh5/icon_off.svg");
        background-size: 79px 40px;
        width: 79px;
      }
      input[type="checkbox"]:checked,
      input[type="radio"]:checked {
        background: url("https://img.bbalt.cn/imgh5/icon_on.svg") no-repeat
          center;
        background-size: 100% 100%;
      }
    }
  }
  .itemBox {
    margin: 0px 32px;
    width: calc(100% - 64px);
    height: 138px;
    border-bottom: 1px solid #ededed;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 32px;
    font-weight: 400;
    &:last-child {
      border: none;
    }
    label {
      width: 200px;
      margin-right: 10px;
      color: #666666;
    }
    input {
      border: none;
      color: #666666;
      &.nickname {
        color: #333;
      }
    }
    .radioClass {
      margin-right: 32px;
      &:last-child {
        margin-left: 48px;
      }
    }
  }
}
</style>
